import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  list: []
}

// getters
export const getters = {
  list: state => state.list
}

// mutations
export const mutations = {
  LIST (state, data) {
    state.list = data
  }
}

// actions
export const actions = {
  async fetchByFilters ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('sp_filter', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('LIST', data.items)
  },
  async update ({ commit }, items) {
    await axios.patch(laroute.route('sp_update', { companyAbbr: store.getters['auth/company'] }), { items })
  },
  async save ({ commit }, items) {
    const { data } = await axios.post(laroute.route('sp_create_many', { companyAbbr: store.getters['auth/company'] }), { items })
    console.log(data)
  },
  async reset ({ commit }) {
    commit('LIST', [])
  },
  async deleteItem ({ commit }, itemId) {
    await axios.delete(laroute.route('sp_delete', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async getPrice ({ commit }, { partnerId, itemMasterId }) {
    const data = await axios.get(laroute.route('get_sp_price', { companyAbbr: store.getters['auth/company'], partnerId, itemMasterId }))
    return data
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/sellingPrice.js